export default __webpack_public_path__ + "static/Cambridge-Assessment-6bc55275025fc60f69a0ff2ad6aed078.pdf";